var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTailBubble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8D71FF",
  d: "M32.5 20.5c-8 2-21 5-27 4.5 8-6 10.5-11.5 5.5-15.5C4 4.5 0 0 0 0h46v18.5s-5.776-.06-13.5 2"
})));
export default SvgTailBubble;